import { Spinner } from '../Spinner/Spinner'

export const PageLoader = () => {
  return (
    <div className="page-loader">
      <Spinner size="lg" label="Loading…" />
    </div>
  )
}
